module.exports = __webpack_public_path__ + "static/pcPal.22eb69ec.png";